<script setup lang="ts">
import Checkbox from '@/components/Checkbox.vue'
import InputError from '@/components/InputError.vue'
import InputLabel from '@/components/InputLabel.vue'
import PrimaryButton from '@/components/PrimaryButton.vue'
import TextInput from '@/components/TextInput.vue'
// import LocationAlert from '@/components/LocationAlert.vue'
import { Head, Link, useForm } from '@inertiajs/vue3'

defineProps<{
  canResetPassword?: boolean
  status?: string
}>()

const form = useForm({
  email: '',
  username: '',
  password: '',
  remember: false,
})

const submit = () => {
  form.post(route('login'), {
    onFinish: () => {
      form.reset('password')
    },
  })
}

const title = 'Login'
</script>

<template>
  <Head :title="title" />

  <div class="divide-y">
    <h5 class="text-2xl text-sky-500">{{ title }}</h5>
    <hr class="h-px my-2 bg-gray-200 border-0 dark:bg-gray-700" />
    <!-- <LocationAlert class="py-2 mt-4" /> -->
  </div>

  <div
    v-if="status"
    class="mb-4 font-medium text-sm text-green-600">
    {{ status }}
  </div>

  <form
    @submit.prevent="submit"
    class="pt-4">
    <div>
      <InputLabel
        for="username"
        value="Email or mobile number" />

      <TextInput
        id="username"
        class="mt-1 block w-full"
        v-model="form.username"
        required
        autofocus
        autocomplete="username" />

      <InputError
        class="mt-2"
        :message="form.errors.username" />
    </div>

    <div class="mt-4">
      <InputLabel
        for="password"
        value="Password" />

      <TextInput
        id="password"
        type="password"
        class="mt-1 block w-full"
        v-model="form.password"
        required
        autocomplete="current-password" />

      <InputError
        class="mt-2"
        :message="form.errors.password" />
    </div>

    <div class="flex flex-row justify-between mt-4">
      <label class="flex items-center">
        <Checkbox
          name="remember"
          v-model:checked="form.remember" />
        <span class="ms-2 text-sm text-gray-400">Remember me</span>
      </label>
      <Link
        v-if="canResetPassword"
        :href="route('password.request')"
        class="text-xs text-blue-400 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
        Forgot your password?
      </Link>
    </div>

    <div class="flex items-center justify-center mt-4">
      <PrimaryButton
        class="w-full bg-orange-500"
        :class="{ 'opacity-25': form.processing }"
        :disabled="form.processing">
        Login
      </PrimaryButton>
    </div>
  </form>

  <div class="mt-4 text-center">
    <span class="text-sm text-gray-600">Don't have an account? </span>
    <Link
      :href="route('register')"
      class="text-sm text-blue-500 hover:text-blue-700 underline">
      Sign up
    </Link>
  </div>
</template>
